import { FC } from 'react'

import { formatCurrencyCent, reportPercents } from 'commons/utils'
import { ButtonGroup, DownloadLink, Layer, Link, PageSectionSecondary, Tooltip } from 'ui/components'
import { Button } from 'ui/components/Buttons'

import { HRRBankAccount } from '../../../../types'

import * as SC from './styles'

export const DepositsFromSales: FC<{ bankAccount: HRRBankAccount; highRiskReviewId: number; index: number }> = (
  props
) => {
  const { bankAccount, highRiskReviewId, index } = props
  const {
    deposits: {
      depositsFromSales: { changesPriorPeriod, currentPeriod, priorPeriod },
      enableEdit,
      showEditButtonTooltip
    },
    enableDepositsExport,
    bankAccountId,
    bankAccountNumber
  } = bankAccount

  return (
    <PageSectionSecondary
      face="outlined"
      title="Deposits From Sales"
      actions={
        <ButtonGroup margin="small">
          {enableDepositsExport && (
            <DownloadLink
              direct
              parametersForm={{
                highRiskReviewId,
                bankAccountId
              }}
              handleError={() => ({})}
              baseUrl="/bank/v1/deposits-data/core-source-download-xlsx"
              name={'Download Deposit Transactions'}
            >
              Download Deposit Transactions
            </DownloadLink>
          )}
          {!enableEdit && showEditButtonTooltip !== null && (
            <Tooltip id={`deposits-edit-${bankAccountNumber}`} type="dark" content={showEditButtonTooltip}>
              <Button face="secondary" disabled>
                Edit
              </Button>
            </Tooltip>
          )}
          {enableEdit && (
            <Link
              to="/mr/$id/$bankAccountId/deposits-edit"
              params={{ id: highRiskReviewId.toString(), bankAccountId: bankAccountId.toString() }}
              search={{
                type: 'custom',
                account: index
              }}
            >
              <Button face="tertiary">Edit</Button>
            </Link>
          )}
        </ButtonGroup>
      }
    >
      <Layer rounded shadowed>
        <SC.Columns>
          <SC.Table>
            <thead>
              <tr>
                <SC.Td rowSpan={2}></SC.Td>
                <SC.Th rowSpan={2}>Total</SC.Th>
                <SC.Th $bottomBorder colSpan={3}>
                  Cash
                </SC.Th>
                <SC.Th rowSpan={2}>Internal Transfers</SC.Th>
                <SC.Th rowSpan={2}>Credit / Debit Cards</SC.Th>
                <SC.Th rowSpan={2}>Checks</SC.Th>
                <SC.Th rowSpan={2}>Other</SC.Th>
              </tr>
              <tr>
                <SC.Th>Deposits</SC.Th>
                <SC.Th>Invoices</SC.Th>
                <SC.Th $forceRightBorder>ATM Load</SC.Th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <SC.Td>Current Period</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.total)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.cashDeposits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.cashInvoices)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.cashATMLoad)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.internalTransfers)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.creditDebitCards)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.checks)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.other)}</SC.Td>
              </tr>
              <tr>
                <SC.Td>Prior Period</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.total)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.cashDeposits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.cashInvoices)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.cashATMLoad)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.internalTransfers)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.creditDebitCards)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.checks)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.other)}</SC.Td>
              </tr>
              <tr>
                <SC.Td>
                  <b>% Change</b>
                </SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.total.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.cashDeposits.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.cashInvoices.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.cashATMLoad.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.internalTransfers.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.creditDebitCards.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.checks.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.other.percent)}</SC.Td>
              </tr>
            </tbody>
          </SC.Table>
        </SC.Columns>
      </Layer>
    </PageSectionSecondary>
  )
}
